// extracted by mini-css-extract-plugin
module.exports = {"tag-group":"style_tag-group__t0qxW"};